import {onBeforeUnmount} from 'vue';

export function useDebounce() {
    let timeout: ReturnType<typeof setTimeout>;

    onBeforeUnmount(() => {
        clearTimeout(timeout);
    });

    return {
        debounce: (callback: any, delay: number) => {
            clearTimeout(timeout);
            timeout = setTimeout(() => callback(), delay);
        },
    };
}
